import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { Game } from 'functions/src/types/firestore/Game';
import { TabPanel } from '..';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { toTitleCase, toKebabCase } from '../../../util/string';
import { ComingSoonText } from 'src/components/coming-soon/ComingSoonText';
import { ReviewsTab } from '../common/ReviewsTab';
import { TournamentsTab } from '../common/TournamentsTab';
import { SystemTab } from '../common/SystemTab';
import { RoadmapTab } from '../common/RoadmapTab';

const TAB_NAMES = ['Tournaments', 'Reviews', 'System', 'Roadmap'];

const ENABLED_TABS = {
  Tournaments: true,
  Reviews: true,
  System: false,
  Roadmap: false,
};

const getTabs = (tabName: string, gameId: string) => {
  if (!ENABLED_TABS[`${tabName}`]) {
    return <ComingSoonText title={`The ${tabName} tab`} />;
  }
  switch (tabName) {
    case 'Tournaments':
      return <TournamentsTab id={gameId} />;
    case 'Reviews':
      return <ReviewsTab id={gameId} />;
    case 'System':
      return <SystemTab id={gameId} />;
    case 'Roadmap':
      return <RoadmapTab id={gameId} />;
    default:
      return null;
  }
};

type WarsakenProps = {
  openTabName: string;
} & Pick<Game, 'id'>;

export const WarsakenTabs = ({ id, openTabName }: WarsakenProps) => {
  const router = useRouter();
  const [tabValue, setTabValue] = useState<number>(
    openTabName
      ? TAB_NAMES.indexOf(toTitleCase(openTabName.split('-').join(' '))) === -1
        ? 0
        : TAB_NAMES.indexOf(toTitleCase(openTabName.split('-').join(' ')))
      : 0,
  );
  const handleTabChange = async (_: React.SyntheticEvent, newValue: number) => {
    const { pid } = router.query;
    await router.push(
      `/game/${pid}/${toKebabCase(TAB_NAMES[Number(newValue)])}`,
      undefined,
      {
        shallow: true,
      },
    );
    setTabValue(newValue);
  };
  return (
    <>
      <Box sx={{ px: 6, mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant={'scrollable'}
          scrollButtons={false}
        >
          {TAB_NAMES.map((tabName) => {
            return <Tab key={tabName} label={tabName} />;
          })}
        </Tabs>
      </Box>
      {TAB_NAMES.map((tabName, index) => {
        return (
          <TabPanel key={tabName} value={tabValue} index={index}>
            {getTabs(tabName, id)}
          </TabPanel>
        );
      })}
    </>
  );
};
